export default "__VITE_ASSET__d2f03279__"